<template>
  <div class="dashboard-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="dashboard-menu">
            <ul>
              <li>
                <router-link to="/user/bang-dieu-khien">
                  <img src="@/assets/img/icons/dashboard-icon.svg" alt="Icon" />
                  <span>Bảng điều khiển</span>
                </router-link>
              </li>
              <li v-if="isBangDieuKhien">
                <a href="#giai-dau"
                >
                  <img src="@/assets/img/icons/booking-icon.svg" alt="Icon" />
                  <span>Giải đấu</span>
                </a>
              </li>
              <li v-if="isBangDieuKhien">
                <a href="#tran-dau">
                  <img src="@/assets/img/icons/chat-icon.svg" alt="Icon" />
                  <span>Trận đấu</span>
                </a>
              </li>
              <li>
                <router-link
                  to="/user/sua-thong-tin"
                >
                  <img src="@/assets/img/icons/profile-icon.svg" alt="Icon" />
                  <span>Thông tin</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPath: this.$route.path, // Initialize currentPath with the current route path
    };
  },
  computed: {
    isBangDieuKhien(){
      if(this.currentPath === '/user/bang-dieu-khien'){
        return true;
      }else{
        return false;
      }    
    }
  }
};
</script>
